<div class="w-full flex flex-col dark:text-white">
  <div class="flex flex-wrap items-center gap-4">
    <div *ngIf="title || useBackButton"
         class="grow overflow-hidden  mt-3 mb-1 {{useBackButton ? ' rounded-[10px] font-semibold dark:border-gray-700':'border !font-extrabold border-l-0 border-r-0 border-t-0 !border-b-[#a6b6bf6e]'}} ">
      <div class="w-full sm:flex sm:flex-row !p-0 mr-0">
        <div class="flex">
          <div *ngIf="useBackButton" class="">
            <mat-icon *ngIf="image" [svgIcon]="image" class="!h-6 !w-6 text-word-primary opacity-70"></mat-icon>
            <div (click)="goBack()"
                 class="h-full content-items rounded-[10px] p-[10px] cursor-pointer  flex items-center justify-center hover-animation"
                 matTooltip="{{ 'Go Back' | concat | translate }}"
                 style="--order:2">
              <mat-icon class="!w-6 !h-6">arrow_back</mat-icon>
            </div>
          </div>
        </div>
        <div class="flex items-center gap-2  ms-3">
        <span
          class="!text-[18px] p-[10px] app-main-heading-title !text-gray-500  tracking-wider text-word-primary dark:!text-white content-item"
          style="--order:2">
          {{ title | titlecase }}
        </span>
        </div>

      </div>
    </div>
    <ng-container *ngxPermissionsOnly="addPermission">
      <ng-container *ngIf="!useDropdownOnCreate">
        <button (click)="add()" *ngIf="!hideAdd && !viewDetails" @fadeIn [ngClass]="routeAnimationsElements"
                class="mx-auto py-1 mt-2 items-center flex flex-wrap add-btn btn-sm dark:!bg-gray-700 dark:!border-0" color="primary"
                mat-flat-button
                style="padding-right: 25px; padding-bottom: 5px; padding-top: 5px">
          <mat-icon>add_circle_outline</mat-icon>
          {{ addButtonName | titlecase }}
        </button>
      </ng-container>
    </ng-container>
  </div>
  <div class="py-[5px] px-[4px] sm:my-auto self-end">
    <ng-container *ngxPermissionsOnly="addPermission">
      <ng-container *ngIf="useDropdownOnCreate == true">
        <button *ngIf="!hideAdd && !viewDetails" @fadeIn [matMenuTriggerFor]="menu"
                [ngClass]="routeAnimationsElements"
                class="!m-0 py-1 items-center flex flex-wrap add-btn btn-sm"
                color="primary"
                mat-flat-button
                style="padding-right: 25px; padding-bottom: 5px; padding-top: 5px">
          <mat-icon>add</mat-icon>
          {{ addButtonName | titlecase }}
        </button>

        <mat-menu #menu="matMenu">
          <button (click)="buttonMenuAction(menuItem)" *ngFor="let menuItem of dropMenuOnCreate" mat-menu-item>
            <mat-icon>{{ menuItem.icon }}</mat-icon>
            <span>{{ menuItem.label }}</span>
          </button>
        </mat-menu>
      </ng-container>
    </ng-container>
  </div>
</div>
<mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
